import $ from "jquery";
import Vue from "vue";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as rt from "../../../routes/routes";
import * as ses from "../../../configurations/session/sessioncomplete";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router/index";

export const actions = {
  newnLabour({ state }) {
    let labourDetails = {
      labour_total: $(".labour_total").val(),
      labour_date: $(".labour_date").val(),
      labour_item: state.labour_item
    };
    // console.log(labour_item);
    $(".creatingLabour").hide();
    $(".creatingLabourLoader").show();
    baseurl.post(rt.newNumberlessLabour, labourDetails).then(res => {
      $(".creatingLabour").show();
      $(".creatingLabourLoader").hide();

      //checking for response codes from backend api

      if (res.data.code === 200) {
        //success code
        suc.laboursCreateSuccess();
        $(".form-control").val("");
        router.push("/managenumberlesslabourcharges");
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 404) {
        //error on creating data
        ers.errorCreatingLabour();
      } else if (res.data.code === 405) {
        //no permission to create
        ers.noPermissionToCreate();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },

  loadnLabours({ commit }) {
    baseurl.get(rt.loadNumberlessLabours).then(res => {
      $(".laboursLoader").hide();

      //checking for response codes from backend api

      if (res.data.code === 200) {
        //committing mutations
        commit("STORE_LABOURS", res.data.numberlesslabours);
      } else if (res.data.code === 404) {
        //error on loading data
        ers.errorLoadingLabour();
      } else if (res.data.code === 405) {
        //no permission to read
        ers.noPermissionToRead();
        commit("STORE_LABOURS", []);
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },

 
};
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/numberlesslabours/actions.js